import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TransformDurationPipe } from './pipe.duration';

/**
 * The TransformDuration module
 *
 * import { TransformDurationModule } from 'styleguide/src/shared/pipe/duration/pipe.duration.module';
 */
@NgModule({
    declarations: [
        TransformDurationPipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TransformDurationPipe
    ]
})

export class TransformDurationModule {}
